module.exports = __webpack_public_path__ + "img/89_16.8fc7481a.png";